const listaDeEstados = (state) => {
    return state.items;
}

const loadingEstado = (state) => {
    return state.carregando
}

export {
    listaDeEstados,
    loadingEstado
}